import { useState, MouseEvent } from 'react';
import { WorkerSlackChannel } from '@scale/shared/workerSlack/types';
import SlackChannelName from './SlackChannelName';
import SlackChannelActions from './SlackChannelActions';
import SlackChannelInfo from './SlackChannelInfo';
import SlackChannelOptions from './SlackChannelOptions';
import SlackChannelOptionsEditor from './SlackChannelOptionsEditor';
import { ICommunityOption } from '@scale/shared/types/Community';

export interface ISlackChannelProps {
  channel: WorkerSlackChannel;
  permissionGroup?: string;
  isLoading: boolean;
  isAdd?: boolean;
  isRemove?: boolean;
  isCurrent?: boolean;
  isRecommended?: boolean;
  disableInviteTaskers?: boolean;
  isEditable?: boolean;
  communityOptions?: ICommunityOption[];
  onEdit?: (channel: WorkerSlackChannel) => void;
  onCancelEdit?: (channel: WorkerSlackChannel) => void;
  onRemove?: (channel: WorkerSlackChannel) => void;
  onCancelRemove?: (channel: WorkerSlackChannel) => void;
  onAddRecommended?: (channel: WorkerSlackChannel) => void;
  onCancelAddRecommended?: (channel: WorkerSlackChannel) => void;
  onPermissionLevelChange?: (reviewLevels: $FIXME[]) => void;
  onPermissionCommunitiesChange?: (communities: ICommunityOption[]) => void;
  onPermissionWorkerSourcesChange?: (workerSources: $FIXME[]) => void;
  onPermissionCountriesChange?: (countries: $FIXME[]) => void;
  onPermissionTierStatusesChange?: (tierStatuses: $FIXME[]) => void;
  onPermissionTagsChange?: (tags: $FIXME[]) => void;
  onPermissionRequireAllTagsChange?: (requireAllTags: boolean) => void;
}

const SlackChannel = (props: ISlackChannelProps) => {
  const [isHover, setIsHover] = useState(false);
  const [copied, setCopied] = useState(false);

  const editPermissionReviewLevel = (reviewLevels: $FIXME[]) => {
    props.onPermissionLevelChange?.(reviewLevels);
  };

  const editPermissionCommunities = (communities: ICommunityOption[]) => {
    props.onPermissionCommunitiesChange?.(communities);
  };

  const editPermissionWorkerSources = (workerSources: $FIXME[]) => {
    props.onPermissionWorkerSourcesChange?.(workerSources);
  };

  const editPermissionCountries = (countries: $FIXME[]) => {
    props.onPermissionCountriesChange?.(countries);
  };

  const editPermissionTierStatuses = (tierStatuses: $FIXME[]) => {
    props.onPermissionTierStatusesChange?.(tierStatuses);
  };

  const editPermissionTags = (tags: $FIXME[]) => {
    props.onPermissionTagsChange?.(tags);
  };

  const editPermissionRequireAllTags = (requireAllTags: boolean) => {
    props.onPermissionRequireAllTagsChange?.(requireAllTags);
  };

  return (
    <>
      <div
        className="channel-container"
        onMouseEnter={(_event: MouseEvent) => {
          setIsHover(true);
        }}
        onMouseLeave={(_event: MouseEvent) => {
          setCopied(false);
          setIsHover(false);
        }}
      >
        <div className="channel-name-container">
          <SlackChannelName {...props} isHover={isHover} copied={copied} setCopied={setCopied} />
          <div className="channel-info-and-actions-container">
            <SlackChannelInfo {...props} />
            <SlackChannelActions {...props} />
          </div>
        </div>
        {props.isAdd || props.channel.toAdd || props.channel.toEdit ? (
          <SlackChannelOptionsEditor
            {...props}
            editPermissionCommunities={editPermissionCommunities}
            editPermissionReviewLevel={editPermissionReviewLevel}
            editPermissionWorkerSources={editPermissionWorkerSources}
            editPermissionCountries={editPermissionCountries}
            editPermissionTierStatuses={editPermissionTierStatuses}
            editPermissionTags={editPermissionTags}
            editPermissionRequireAllTags={editPermissionRequireAllTags}
          />
        ) : (
          <SlackChannelOptions {...props} />
        )}
      </div>
      <style jsx>{`
        .channel-container {
          display: flex;
          flex-direction: column;
          padding: 24px 18px;
          max-width: 690px;
          font-weight: 500;
          font-size: 15px;
          background-color: ${props.isRemove
            ? `var(--color-RemoGray75)`
            : `var(--color-RemoGray01)`};
          margin: 6px 0px;
          opacity: ${props.isRemove ? `0.6` : `1`};
          background: #ffffff;
          border: 0.5px solid #ffffff;
          box-shadow: 0px 0px 4px rgba(17, 24, 39, 0.2);
          border-radius: 4px;
        }

        .channel-name-container {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
        }

        .channel-info-and-actions-container {
          display: flex;
          flexdirection: row;
          alignitems: center;
          gap: 8px;
        }
      `}</style>
    </>
  );
};

export default SlackChannel;
